import { FINISH_SHOW_MORE_ACTIVITIES } from './txns'

export default function reducer(
  state = { contributors: { map: {} }, txns: { list: [], txns_per_page: 10 } },
  action
) {
  switch (action.type) {
    case FINISH_SHOW_MORE_ACTIVITIES: {
      const newContributors =
        action.payload.response && action.payload.response.contributors
      const newTxns = action.payload.response && action.payload.response.txns
      return {
        ...state,
        contributors: {
          map: {
            ...state.contributors.map,
            ...newContributors.map,
          },
        },
        txns: {
          ...state.txns,
          list: [...state.txns.list, ...newTxns.list],
        },
      }
    }
    default:
      return state
  }
}
